import React from 'react';

import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import NextLink from '@src/components/Shared/NextLink';
import SectionHeader from '@src/components/Shared/SectionHeader';

import { ImageTextPrimaryPropTypes } from './ImageTextSecondary.types';

const ImageTextSecondary: React.FC<ImageTextPrimaryPropTypes> = ({
  entryId = '',
  id,
  className,
  pretitle,
  title,
  imgURL,
  imgLink = '',
  imgAlt = '',
  background = '',
  childrenElements,
  reversed = false,
  objectFit = 'cover',
  imgChildElements = null,
  titleClassName = '',
  priority,
  imgFirstRatio = 16 / 9,
  imgFirstClassName = '',
  imgSecondClassName = '',
  textContainerClassName = '',
  sectionHeaderClassName = '',
}) => {
  return (
    <Container
      id={id}
      className={`flex flex-col gap-[4.2rem] overflow-y-hidden lg:flex-row lg:items-center lg:gap-[6.4rem] ${className}`}
      background={background}
    >
      {/* Mobile Image (always first) */}
      {imgLink ? (
        <NextLink href={imgLink} className='lg:hidden' title={imgAlt}>
          <NextImage
            entryId={entryId}
            className={`lg:mb-[unset] ${imgFirstClassName}`}
            src={imgURL}
            alt={imgAlt}
            aspectRatio={imgFirstRatio}
            priority={priority}
            width={100}
            objectFit={objectFit}
          >
            {imgChildElements}
          </NextImage>
        </NextLink>
      ) : (
        <NextImage
          entryId={entryId}
          className={`lg:mb-[unset] lg:hidden ${imgFirstClassName}`}
          src={imgURL}
          alt={imgAlt}
          aspectRatio={imgFirstRatio}
          priority={priority}
          width={100}
          objectFit={objectFit}
        >
          {imgChildElements}
        </NextImage>
      )}

      {/* Desktop Image - Wrap in a div for proper ordering */}
      <div
        className={`hidden lg:block lg:w-[50%] ${imgSecondClassName} ${reversed ? 'lg:order-2' : 'lg:order-1'}`}
      >
        {imgLink ? (
          <NextLink href={imgLink} title={imgAlt}>
            <NextImage
              entryId={entryId}
              className={`relative z-[-5]`}
              src={imgURL}
              alt={imgAlt}
              objectFit={objectFit}
            >
              {imgChildElements}
            </NextImage>
          </NextLink>
        ) : (
          <NextImage
            entryId={entryId}
            className={`relative z-[-5]`}
            src={imgURL}
            alt={imgAlt}
            objectFit={objectFit}
          >
            {imgChildElements}
          </NextImage>
        )}
      </div>

      {/* Text Content - Wrap in a div for proper ordering */}
      <div
        className={`lg:relative lg:z-20 lg:w-[50%] lg:self-center ${reversed ? 'lg:order-1' : 'lg:order-2'} ${textContainerClassName}`}
      >
        <SectionHeader
          className={`relative z-5 lg:py-[4rem] ${sectionHeaderClassName}`}
          pretitle={pretitle}
          preTitleClassName='mb-[1.6rem] font-normal'
          title={title}
          entryId={entryId}
          titleClassName={`text-[2.8rem] mb-[1.8rem] lg:mb-[3.2rem] lg:text-[4.8rem] lg:leading-[5.2rem] lg:tracking-[-0.096rem] ${titleClassName}`}
          childrenClassName='relative'
          align='left'
        >
          {childrenElements}
        </SectionHeader>
      </div>
    </Container>
  );
};

export default ImageTextSecondary;
